import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';
import { useLanguage } from '@/components/useLanguage';
import PhoneClosureNotice from '@/components/PhoneClosureNotice';

export default function PortalHeader({ onLeaveClick }) {
  const { t, lang } = useLanguage();

  return (
    <header className="bg-[#F8F8F8] border-b border-gray-200 shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo - clicking also triggers leave warning */}
          <button onClick={onLeaveClick} className="flex items-center">
            <img 
              src="https://base44.app/api/apps/691da83d30e4689f56b0df07/files/mp/public/691da83d30e4689f56b0df07/77ba4fb0d_d9c1ec595_Enkel_LOGO-281.png" 
              alt="enkel energi" 
              className="h-16 object-contain object-left"
            />
          </button>

          <div className="flex items-center gap-2">
            {/* Prisgaranti link */}
            <Link
              to="/portal/smart-charge"
              target="_blank" rel="noopener noreferrer"
              className="flex items-center gap-2 px-4 py-2 bg-[#F6F3EC] hover:bg-[#E9DFC9] text-[#2F424D] rounded-lg text-sm font-semibold transition-colors"
            >
              <Shield className="w-4 h-4" />
              <span className="hidden sm:inline">Prisgaranti</span>
            </Link>
            {/* Back button */}
            <button
              onClick={onLeaveClick}
              className="flex items-center gap-2 px-4 py-2 bg-gray-900 hover:bg-gray-800 text-white rounded-lg text-sm font-semibold transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="hidden sm:inline">{t('customerPortal.leavePortal')}</span>
              <span className="sm:hidden">{t('common.back')}</span>
            </button>
          </div>
        </div>
      </div>
      <PhoneClosureNotice en={lang === 'en'} />
    </header>
  );
}